import React from "react";

const TemarioDiplomaturaNutricionMicrobiota = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Microbiota, microbioma y metagenómica"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Definición de cada concepto"}</span></li>
                <li><span className="fw-light">{"Composición de la Microbiota: géneros, especies y cepas"}</span></li>
                <li><span className="fw-light">{"Grupos de microorganismos que interaccionan con la especie humana: bacterias, hongos, virus y protozoos"}</span></li>
                <li><span className="fw-light">{"Conceptos de: simbiosis, comensalismo, mutualismo, parasitismo"}</span></li>
                <li><span className="fw-light">{"Diferentes Microbiotas humanas"}</span></li>
                <li><span className="fw-light">{"Generalidades"}</span></li>
                <li><span className="fw-light">{"Microbiota Gastrointestinal"}</span></li>
                <li><span className="fw-light">{"Microbiota Oral"}</span></li>
                <li><span className="fw-light">{"Microbiota de la Piel"}</span></li>
                <li><span className="fw-light">{"Microbiota del Tracto Respiratorio"}</span></li>
                <li><span className="fw-light">{"Microbiota del Tracto Urinario"}</span></li>
                <li><span className="fw-light">{"Microbiota del Aparato Reproductor"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiología en medicina"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Concepto y desarrollo de la Microbiología"}</span></li>
                <li><span className="fw-light">{"Ubicación de los microorganismos en el mundo vivo"}</span></li>
                <li><span className="fw-light">{"Bacterias, organismos procariotas, características generales, metabolismo y fisiología"}</span></li>
                <li><span className="fw-light">{"Genética bacteriana, taxonomía"}</span></li>
                <li><span className="fw-light">{"Virus, caracteres generales, métodos de estudio, composición química, estructura de los virus y grupos de virus"}</span></li>
                <li><span className="fw-light">{"Hongos y sus caracteres generales"}</span></li>
                <li><span className="fw-light">{"Interacciones entre microorganismos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota hoy"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Dieta y estilo de vida"}</span></li>
                <li><span className="fw-light">{"Eje Microbiota-intestino-cerebro"}</span></li>
                <li><span className="fw-light">{"Factores que influyen en el estado de la microbiota"}</span></li>
                <li><span className="fw-light">{"Composición de la microbiota intestinal en las diferentes etapas de la vida"}</span></li>
                <li><span className="fw-light">{"Envejecimiento y microbiota"}</span></li>
                <li><span className="fw-light">{"Actualizaciones en investigación científica"}</span></li>
                <li><span className="fw-light">{"¿Qué es y para qué sirve el trasplante fecal"}</span></li>
            </ul>
            <br /><br />
            <b>{"Aparato digestivo y homeostasis intestinal"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Fisiología del aparato digestivo"}</span></li>
                <li><span className="fw-light">{"Composición de la microbiota en las diferentes partes del tubo digestivo"}</span></li>
                <li><span className="fw-light">{"Microbiota del intestino delgado en individuos sanos"}</span></li>
                <li><span className="fw-light">{"Microbiota del colon en individuos sanos"}</span></li>
                <li><span className="fw-light">{"Composición de la microbiota"}</span></li>
                <li><span className="fw-light">{"Microbiota protectora (Lactobacillus, Bifidobacterium, Bacteroides)"}</span></li>
                <li><span className="fw-light">{"Microbiota inmunomoduladora (Enterococcus faecalis y Escherichia coli)"}</span></li>
                <li><span className="fw-light">{"Microbiota muconutritiva o mucoprotectora (Faecalibacterium prausnitzii y Akkermansia muciniphila)"}</span></li>
                <li><span className="fw-light">{"Microbiota con actividades proteolítica o proinflamatoria, E. coli Biovare, Clostridium, Proteus, Pseudomonas"}</span></li>
                <li><span className="fw-light">{"Enterobacter, Citrobacter, Klebsiella, Desulfovibrio, Bilophila"}</span></li>
                <li><span className="fw-light">{"Microbiota fúngica (Candida, Geotrichum)"}</span></li>
            </ul>
            <br /><br />
            <b>{"Profundización en homeostasis intestinal"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Funciones de la microbiota intestinal: metabólicas, nutritivas y tróficas"}</span></li>
                <li><span className="fw-light">{"Funciones protectoras y de barrera Inmunitarias"}</span></li>
                <li><span className="fw-light">{"Interrelaciones entre la microbiota intestinal y órganos alejados (cerebro, pulmón, corazón, hígado, páncreas, etc.)"}</span></li>
                <li><span className="fw-light">{"Mucosa intestinal y Sistema inmunitario de la mucosa"}</span></li>
                <li><span className="fw-light">{"Anatomía, características y funciones (Sistema MALT, GALT Y BALT)"}</span></li>
                <li><span className="fw-light">{"¿Qué es la Homeostasis intestinal? Papel de las bacterias sobre la homeostasis"}</span></li>
                <li><span className="fw-light">{"Efectos sobre la digestión y la nutrición"}</span></li>
                <li><span className="fw-light">{"Estimulación de las defensas, dificultar la colonización por microorganismos patógenos"}</span></li>
                <li><span className="fw-light">{"Producción de vitaminas de los grupos B y K"}</span></li>
                <li><span className="fw-light">{"Producción de ácidos grasos de cadena corta (butírico, propiónico, acético, etc.)"}</span></li>
                <li><span className="fw-light">{"Producción de gases (metano, dióxido de carbono, hidrógeno molecular)"}</span></li>
                <li><span className="fw-light">{"Propiedades y funciones"}</span></li>
                <li><span className="fw-light">{"El ácido láctico"}</span></li>
            </ul>
            <br /><br />
            <b>{"Patologías y microbiota intestinal, disbiosis intestinal y SIBO"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"¿Qué es la Disbiosis intestinal"}</span></li>
                <li><span className="fw-light">{"La barrera intestinal, fisiología, función, permeabilidad intestinal e hiperpermeabilidad intestinal"}</span></li>
                <li><span className="fw-light">{"Relación entre Disbiosis intestinal e hiperpermeabilidad intestinal"}</span></li>
                <li><span className="fw-light">{"Relación de la Disbiosis intestinal y otros tipos de desórdenes: inmunológicos, metabólicos"}</span></li>
                <li><span className="fw-light">{"Neurológicos y gástricos (Helicobacter Pylori)"}</span></li>
                <li><span className="fw-light">{"Trastornos Funcionales Digestivos"}</span></li>
                <li><span className="fw-light">{"Enfermedad inflamatoria intestinal (EII)"}</span></li>
                <li><span className="fw-light">{"Enfermedades inflamatorias crónicas intestinales: enfermedad de Crohn y colitis ulcerosa"}</span></li>
                <li><span className="fw-light">{"Síndrome de Intestino Irritable (SII). Marcadores de permeabilidad: Alfa 1 Antitripsina, Zonulina"}</span></li>
                <li><span className="fw-light">{"Las Tight Juntions y su función principal"}</span></li>
                <li><span className="fw-light">{"Diveticulosis"}</span></li>
                <li><span className="fw-light">{"Diarrea. Diarrea provocada por Clostridium difficile"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota y sistema inmunitario"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Fisiología del sistema inmunitario"}</span></li>
                <li><span className="fw-light">{"Componentes del Sistema Inmunitario"}</span></li>
                <li><span className="fw-light">{"Tejido Linfoide"}</span></li>
                <li><span className="fw-light">{"Células Inmunitarias"}</span></li>
                <li><span className="fw-light">{"Sistemas Químicos"}</span></li>
                <li><span className="fw-light">{"Órganos que intervienen en la inmunidad"}</span></li>
                <li><span className="fw-light">{"Órganos primarios"}</span></li>
                <li><span className="fw-light">{"Órganos secundarios"}</span></li>
                <li><span className="fw-light">{"Inmunidad innata, inespecífica o natural"}</span></li>
                <li><span className="fw-light">{"Inmunidad adquirida, adaptativa o específica"}</span></li>
                <li><span className="fw-light">{"Relación bidireccional entre Microbiota y sistema Neuroinmunoendocrino Microbiota, Inmunidad y Trastornos del Sistema Nervioso"}</span></li>
                <li><span className="fw-light">{"Investigación científica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Relación intolerancias, alergias y microbiota"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Microbiota e intolerancias a la lactosa"}</span></li>
                <li><span className="fw-light">{"Microbiota e intolerancias a las proteínas lácteas: caseínas, albúminas, etc"}</span></li>
                <li><span className="fw-light">{"Microbiota y alergias a la leche"}</span></li>
                <li><span className="fw-light">{"Microbiota e Intolerancia al gluten"}</span></li>
                <li><span className="fw-light">{"Microbiota y enfermedad celiaca (EC)"}</span></li>
            </ul>
            <br /><br />
            <b>{"Fundamentos de alimentos funcionales y nutracéuticos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Profundizar en los probióticos"}</span></li>
                <li><span className="fw-light">{"Definición"}</span></li>
                <li><span className="fw-light">{"Historia"}</span></li>
                <li><span className="fw-light">{"Mecanismos de acción"}</span></li>
                <li><span className="fw-light">{"Probióticos en argentina y el mundo"}</span></li>
                <li><span className="fw-light">{"Actualidad sobre Investigación científica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Aplicaciones clínicas de alimentos funcionales y nutracéuticos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Productos lácteos como fuente natural de Probióticos y prebióticos"}</span></li>
                <li><span className="fw-light">{"Alimentos fermentados que impulsan una Microbiota saludable"}</span></li>
                <li><span className="fw-light">{"Taller"}</span></li>
            </ul>
            <br /><br />
            <b>{"Estrategias nutricionales con alimentos funcionales y nutracéuticos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Profundizar en los prebióticos"}</span></li>
                <li><span className="fw-light">{"Definición"}</span></li>
                <li><span className="fw-light">{"Historia"}</span></li>
                <li><span className="fw-light">{"Mecanismos de acción"}</span></li>
                <li><span className="fw-light">{"Posbioticos"}</span></li>
                <li><span className="fw-light">{"Sinbioticos"}</span></li>
                <li><span className="fw-light">{"Actualidad científica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Vegetarianismo y veganismo"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Alimentación vegana"}</span></li>
                <li><span className="fw-light">{"Alimentación vegetariana"}</span></li>
                <li><span className="fw-light">{"Errores frecuentes"}</span></li>
                <li><span className="fw-light">{"Balance energético"}</span></li>
                <li><span className="fw-light">{"Buen balance del consumo de proteínas y fuentes de proteína para la microbiota"}</span></li>
                <li><span className="fw-light">{"Grasas vegetales y microbiota"}</span></li>
                <li><span className="fw-light">{"Vitaminas y minerales"}</span></li>
                <li><span className="fw-light">{"Aporte correcto de Vitamina B12"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota, embarazo y los primeros 1000 días de vida"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Simbiosis madre e hijo"}</span></li>
                <li><span className="fw-light">{"Factores influyentes en la Microbiota intestinal de la madre en la etapa gestacional y en el momento del parto"}</span></li>
                <li><span className="fw-light">{"Tipo de parto: influencia en la Microbiota del neonato"}</span></li>
                <li><span className="fw-light">{"Lactancia materna y microbiota del bebé"}</span></li>
                <li><span className="fw-light">{"Probióticos y prebióticos en el paciente pediátrico"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaNutricionMicrobiota;
